import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteCurrencySection', {
    currenyFieldText: 'Currency',
    currenyFieldPlaceholder: 'Select currency',
    differentCurrencyWarningLabel1: 'Bill currency:',
    differentCurrencyWarningLabel2: 'File currency:',
    differentCurrencyWarningDescription: 'Bill currency differs from File currency.',
    missingCurrencyWarning: "Bill currency doesn't exist in NetSuite",
});
